'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from 'contexts/InAppProvider';
import { EventsPage } from 'app/(appHeader)/events/EventsPage';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');

  return (
    <>
      <title>이벤트 목록 | 디리토</title>
      <EventsPage isApp={isApp} />
    </>
  );
}
